var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGatedArea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.9009 16.3306V8.5C2.9009 7.39543 3.79633 6.5 4.9009 6.5H6.2925C6.90714 6.5 7.40541 6.99826 7.40541 7.6129V7.6129M2.9009 16.3306H7.40541M2.9009 16.3306V16.3306C2.40335 16.3306 2 16.734 2 17.2315V17.4153C2 18.0144 2.48563 18.5 3.08468 18.5H7.22163C7.82068 18.5 8.30631 18.0144 8.30631 17.4153V17.2315C8.30631 16.734 7.90296 16.3306 7.40541 16.3306V16.3306M7.40541 16.3306V10.3952M7.40541 7.6129V10.3952M7.40541 7.6129H10.7613M7.40541 10.3952H9.5M19.7568 10.3952V18.5M19.7568 10.3952H19.1982M19.7568 10.3952H16M21.4595 18.5H20.1982M18.3153 18.5H19.7568M19.7568 18.5H20.1982M19.1982 10.3952H20.6089C21.3772 10.3952 22 9.77233 22 9.00403V9.00403C22 8.23573 21.3772 7.6129 20.6089 7.6129H20.4595M19.1982 10.3952L20.4595 7.6129M20.1982 18.5V10.3952M10.7613 7.6129L9.5 10.3952M10.7613 7.6129H14M9.5 10.3952H12.7387M12.7387 10.3952L14 7.6129M12.7387 10.3952H16M14 7.6129H17.2613M17.2613 7.6129L16 10.3952M17.2613 7.6129H20.4595",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGatedArea);
export default __webpack_public_path__ + "static/media/gated_area.9e7a4acf3f1f5c1188645a88330bd31a.svg";
export { ForwardRef as ReactComponent };